module.exports = __webpack_public_path__ + "media/img/logos/tak_gov_icon_text_blk-b04480f0c81b5849e0bdd00617c92d4a.svg";